<template>
  <div>
    <template v-if="view_transfer_out === true ">
      <div class="employee-view-tabs mb-4">
        <ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="reversal-transfer-tab" data-toggle="tab" href="#reversal-transfer" role="tab" aria-controls="reversal-transfer" aria-selected="false">Reversal Transfer</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="correction-tab" data-toggle="tab" href="#correction" role="tab" aria-controls="loan-amount-ledger-correction" aria-selected="false">Loan Amount Ledger Correction</a>
          </li>
        </ul>
      </div>
      <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="reversal-transfer" role="tabpanel" aria-labelledby="reversal-transfer">
      <div class="page-top mb-1 mb-3 clearfix">
        <h1 class="float-left"> Reversal Transfer </h1>
      </div>
      <div class="global-main">
        <div class="people-management-inner-content">
          <form @submit.prevent="insertData()" id="transferOut">
            <div class="tab-content-inner">
              <div class="user-permissions">
                <div class="form-group">
                  <label class="label block-label"> Company <em class="required">*</em></label>
                  <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                    <option value="" selected>Select Company</option>
                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                      {{ company.name }}
                    </option>
                  </select>
                  <has-error :form="form" field="company_id"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Wallet ID <em class="required">*</em></label>
                  <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                    <option value="" selected>Select Wallet ID</option>
                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                      {{ company.walletID }}
                    </option>
                  </select>
                  <has-error :form="form" field="company_id"></has-error>
                </div>
                <div class="form-group" v-show="form.company_id">
                  <span>
                    <div v-for="company in companies">
                      <div v-show="company.id == form.company_id">
                        <h3> Available Lending Balance => Rs.{{new Intl.NumberFormat().format(company.loan_amount)}}</h3>
                      </div>
                    </div>
                  </span>
                </div>
                <div class="form-group" :class="{ 'calendar-error': form.errors.has('date') }">
                  <label class="label block-label"> Date <em class="required">*</em></label>
                  <datepicker name="date" input-class="datepicker" :bootstrap-styling="true" :clear-button="true"
                              placeholder="Select Date" v-model="form.date"
                              :input-class="{ 'is-invalid': form.errors.has('date') }"></datepicker>
                  <has-error :form="form" field="date"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Transaction No <em class="required">*</em></label>
                  <input v-model="form.transaction_id" type="text" name="transaction_id" class="form-control"
                         :class="{ 'is-invalid': form.errors.has('transaction_id') }" autocomplete="off">
                  <has-error :form="form" field="transaction_id"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Type <em class="required">*</em></label>
                  <select v-model="form.type" name="type" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('type') }">
                    <option value="" selected>Select Type</option>
                    <option value="CREDIT">CREDIT</option>
                    <option value="DEBIT">DEBIT</option>
                  </select>
                  <has-error :form="form" field="type"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Amount <em class="required">*</em></label>
                  <input v-model="form.amount" type="text" name="amount" class="form-control"
                         :class="{ 'is-invalid': form.errors.has('amount') }" autocomplete="off">
                  <has-error :form="form" field="amount"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Description </label>
                  <input v-model="form.description" type="text" name="description" class="form-control"
                         :class="{ 'is-invalid': form.errors.has('description') }" autocomplete="off">
                  <has-error :form="form" field="description"></has-error>
                </div>

                <div class="page-top mb-1 mb-3 clearfix" v-if="crud_transfer_out == true">
                  <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                  <router-link to="/" class="btn btn-primary float-right mr-1"> Cancel</router-link>
                </div>
              </div>

            </div>

          </form>
        </div>
      </div>
      </div>
      <div class="tab-pane fade" id="correction" role="tabpanel" aria-labelledby="loan-amount-ledger-correction">
        <div class="tab-pane fade show active" id="reversal-transfer" role="tabpanel" aria-labelledby="reversal-transfer">
          <div class="page-top mb-1 mb-3 clearfix">
            <h1 class="float-left"> Loan Amount Ledger Correction </h1>
          </div>
        <div class="global-main">
        <div class="people-management-inner-content">
          <form @submit.prevent="correction()" id="correction">
            <div class="tab-content-inner">
              <div class="user-permissions">
                <div class="form-group">
                  <label class="label block-label"> Company <em class="required">*</em></label>
                  <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                    <option value="" selected>Select Company</option>
                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                      {{ company.name }}
                    </option>
                  </select>
                  <has-error :form="form" field="company_id"></has-error>
                </div>
                <div class="form-group">
                  <label class="label block-label"> Wallet ID <em class="required">*</em></label>
                  <select id="company" v-model="form.company_id" @change="selectpickerOnchange()" data-live-search="true" name="company_id" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                    <option value="" selected>Select Wallet ID</option>
                    <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                      {{ company.walletID }}
                    </option>
                  </select>
                  <has-error :form="form" field="company_id"></has-error>
                </div>
                <div class="form-group" v-show="form.company_id">
                  <span>
                    <div v-for="company in companies">
                      <div v-show="company.id == form.company_id">
                        <h3> Available Lending Balance => Rs.{{new Intl.NumberFormat().format(company.loan_amount)}}</h3>
                      </div>
                    </div>
                  </span>
                </div>
                <div class="page-top mb-1 mb-3 clearfix" v-if="crud_transfer_out == true">
                  <button :disabled="form.busy" class="btn btn-primary float-right active">Auto Correct Loan Amount Ledger</button>
                </div>
              </div>

            </div>

          </form>
        </div>
          </div>
          </div>
      </div>
      </div>
    </template>
    <template v-else-if="view_transfer_out === null">
      <preLoader></preLoader>
    </template>
    <template v-else-if="view_transfer_out === false">
      <notAllowed></notAllowed>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      companies: [],
      form: new Form({
        company_id: '',
        amount: '',
        transaction_id: '',
        description: '',
        type: '',
        date: new Date()
      }),

      view_transfer_out: null,
      crud_transfer_out: null,
    }
  },
  methods: {
    insertData() {
      this.$Progress.start();
      Swal.fire({
        title: 'Are you sure?',
        text: 'New entry in Loan Amount Ledger will be inserted!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Proceed'
      }).then((result) => {
        if (result.value) {
          this.form.date = moment(this.form.date).format();
          this.form.post('/api/financeReversalTransfer')
              .then(res => {
                let responseData = res.data;
                if (responseData.code == 200) {
                  // $('#transferOut')[0].reset();
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
                  toast.fire({
                    type: 'success',
                    title: responseData.message
                  });
                  // this.$router.push('/financeLedgerReport');
                  this.$Progress.finish();
                } else if (responseData.code == 201) {
                  this.showAlertBox('error', responseData.message);
                  this.$Progress.fail();
                } else {
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
                  this.$Progress.fail();
                }
              })
              .catch(err => {
                this.$Progress.fail();
                $(this.$el).find('.selectpicker').selectpicker('refresh');
                this.showAlertBox('error', 'Some problem in your form data');
              });
        }

      })

    },
    correction() {
      this.$Progress.start();
      Swal.fire({
        title: 'Are you sure?',
        text: 'Correction process will run on Loan Amount Ledger for selected company!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Procees'
      }).then((result) => {
        if (result.value) {
          this.form.date = moment(this.form.date).format();
          this.form.post('/api/loanAmountLedgerAutoCorrection')
              .then(res => {
                let responseData = res.data;
                if (responseData.code == 200) {
                  $('#transferOut')[0].reset();
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
                  toast.fire({
                    type: 'success',
                    title: responseData.message
                  });
                  // this.$router.push('/financeLedgerReport');
                  this.$Progress.finish();
                } else if (responseData.code == 201) {
                  this.showAlertBox('error', responseData.message);
                  this.$Progress.fail();
                } else {
                  $(this.$el).find('.selectpicker').selectpicker('refresh');
                  this.$Progress.fail();
                }
              })
              .catch(err => {
                this.$Progress.fail();
                $(this.$el).find('.selectpicker').selectpicker('refresh');
                this.showAlertBox('error', 'Some problem in your form data');
              });

        }

      })
    },
    selectpickerOnchange(){
      var select=this.$el;
      setTimeout(()=>{
        $(select).find('.selectpicker').selectpicker('refresh');
      },0);
    },
    getCompanies() {
      this.$Progress.start();
      axios.get('/api/getCompanies')
          .then(res => {
            if (res.status == 200) {
              this.companies = res.data;
              this.$Progress.finish();
            } else {
              this.$Progress.fail();
              this.showAlertBox('error', 'Some error in your form data');
            }
          }).then(res => {
        $(this.$el).find('.selectpicker').selectpicker('refresh');
      })
          .catch(err => {
            $(this.$el).find('.selectpicker').selectpicker('refresh');
            this.showAlertBox('error', 'Some error in your form data');
          });
    }

  },
  mounted() {
    this.$Progress.start();
    this.can('transfer_out|crud_transfer_out').then(result => {
      this.view_transfer_out = result.transfer_out;
      this.crud_transfer_out = result.crud_transfer_out;
    }).then(result => {
      if (this.view_transfer_out == true) {
        this.getCompanies();
        this.$Progress.finish();
      } else {
        this.$Progress.finish();
      }
    });
  }
}
</script>
